/* VELARA — optional GSAP choreography.
   Enhancement only. Everything is already visible via the CSS reveal in
   theme.js, so a CDN failure or a blocked script degrades silently. */
(function () {
  'use strict';
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!window.gsap || !window.ScrollTrigger) return;

  gsap.registerPlugin(ScrollTrigger);

  /* Hero image drifts slowly behind the type. The type itself never moves. */
  var hero = document.querySelector('[data-parallax]');
  if (hero) {
    gsap.to(hero, {
      yPercent: 10, ease: 'none',
      scrollTrigger: { trigger: hero.closest('section'), start: 'top top', end: 'bottom top', scrub: 0.6 }
    });
  }

  /* Editorial figures drift a few percent against the scroll direction. */
  document.querySelectorAll('[data-drift]').forEach(function (el) {
    gsap.fromTo(el, { yPercent: 3.5 }, {
      yPercent: -3.5, ease: 'none',
      scrollTrigger: { trigger: el, start: 'top bottom', end: 'bottom top', scrub: 0.8 }
    });
  });

  /* Statement typography rises once, slower than the generic reveal. */
  document.querySelectorAll('[data-statement]').forEach(function (el) {
    gsap.fromTo(el, { y: 30, opacity: 0 }, {
      y: 0, opacity: 1, duration: 1.1, ease: 'power2.out',
      scrollTrigger: { trigger: el, start: 'top 84%', once: true }
    });
  });

  /* Spectrum swatches light up in sequence, once. */
  var spectrum = document.querySelector('[data-spectrum]');
  if (spectrum) {
    gsap.fromTo(spectrum.querySelectorAll('.spectrum__i'),
      { opacity: 0, y: 14 },
      { opacity: 1, y: 0, duration: .6, stagger: .07, ease: 'power2.out',
        scrollTrigger: { trigger: spectrum, start: 'top 80%', once: true } });
  }
})();
